import React, { useState, useEffect } from "react";
import { store } from "../../redux/oldStore";
import { toast } from "react-toastify";
import FileDownload from 'js-file-download';
import { UploadType } from './ParticipantsUpload';
import { splitCSV } from '../../utils/Tools';
import { ColumnData } from "../../utils/CommonTypes/CommonTypes";




const JudgesUpload = (props: any) => {
  // Lifted straight from AcaDeca LoadJudges

  const [fileText, setFileText] = useState<any>(null);
  const [headersIncluded, setHeadersIncluded] = useState(false)
  const [loaded, setLoaded] = useState(false);
  const [parsingErrors, setParsingErrors] = useState<any[] | null>([]);
  const [sendWelcomeEmail, setSendWelcomeEmail] = useState(true);
  const [sendSignInCredentials, setSendSignInCredentials] = useState(true);
  const [requirePasswordChange, setRequirePasswordChange] = useState(true);
  const [uploadType, setUploadType] = useState<UploadType>('comma');
  const [customQuestionsPerson, setCustomQuestionsJudge] = useState<ColumnData[]>([]);
  const [additionalColumns, setAdditionalColumns] = useState<ColumnData[]>([]);
  const [columnToAdd, setColumnToAdd] = useState<ColumnData>();

  useEffect(() => {

  }, []);

  
 useEffect(() => {
  store.server.getApi(`../import/info`)
    .then((res: any) => {
      console.log(res);
      setCustomQuestionsJudge(res.Value.CustomQuestionsJudge.map(q => { return { value: q.text, id: q.value}}));
    })
    .catch(err => {
      console.error(err);
    })
 }, []);

 
 const handleAddColumn = () => {
  if (columnToAdd) setAdditionalColumns([...additionalColumns, columnToAdd])
  setColumnToAdd(undefined);
  
};

const handleRemoveCol = (id: string) => {
  setAdditionalColumns(additionalColumns.filter( x => x.id !== id));
};

const handleColumnToAddChange = (e: any) => {
  let index = e.nativeEvent.target.selectedIndex;
  let formattedColumn = {
    id: e.target.value,
    value: e.nativeEvent.target[index].text
  };
  // console.log(e, formattedColumn);
  setColumnToAdd(formattedColumn);
}

  const judgeCSVFileSelected = (e: any) => {
    let file = e.target.files[0];
    const reader = new FileReader();
    reader.onload = async (e: any) => {
      const text = e.target.result;
      let lines: any[] = [];
      const perrors: string[] = [];
      let formattedText = text.replaceAll('\r\n',' \n').replaceAll('\r', ' \n');
      const rawLines = formattedText.split("\n");
      rawLines.forEach((l, index) => {
        if(l.length > 0){
          const line = splitCSV(l, uploadType);
          const columnsPerLine = 15 + additionalColumns.length;
          if (line.length === columnsPerLine) {
            //The line looks good
            lines.push(line);
          } else {
            const errorMessage = `Line ${index + 1} has ${line.length} columns, but should have ${columnsPerLine}`
            console.error(errorMessage);
            perrors.push(errorMessage);
          }
        }
      });
      if (perrors.length) {
        setParsingErrors(perrors);
      } else {
        setFileText(lines);
        setParsingErrors(null);
      }
    };
    reader.readAsText(file, 'utf-8-sig');
  };

  const load = (e) => {
    console.log('Sending to server...', fileText);
    // bring in the schoolText somewhere
    let realText = headersIncluded ? fileText.slice(1) : fileText
    store.server.postApi("../Import/loadJudges", { 
        JudgeData: realText,
        sendWelcomeEmail,
        sendSignInCredentials,
        requirePasswordChange,
        additionalColumns: additionalColumns.map(x => x.id)
      }).then((x: any) => {
      if (x.Success) {
        toast.success("Your judges have been loaded.");
        setLoaded(true);
      } else {
        toast.error(x.Message);
      }
    }).catch(err => {
      console.log(err);
      toast.error(err);
    });
  };

  const downloadTemplateClick = () => { 
    let moreColumns = additionalColumns.reduce((acc, col) => {
      let { id, value } = col
      return {...acc, [value]: ''}
    }, {})
    const items = [{
      ['First Name']: '',
      ['Last Name']: '',
      ['Email']: '',
      ['Phone']: '',
      ['Street']: '',
      ['Street 2']: '',
      ['City']: '',
      ['State']: '',
      ['Zip']: '',
      ['Desired username (if blank one will be set)']: '',
      ['Desired password (if blank one will be set)']: '',
      ['Employer/Organization']: '',
      ['Category preference 1']: '',
      ['Category preference 2']: '',
      ['Category preference 3']: '',
      ...moreColumns
     }]
      
     const replacer = (key, value) => value === null ? '' : value // specify how you want to handle null values here
     const header = Object.keys(items[0])
     const csv = [
       header.join(','), // header row first
       ...items.map(row => header.map(fieldName => JSON.stringify(row[fieldName], replacer)).join(','))
     ].join('\r\n')
     
     console.log(csv)
     // downloady stuff here
     FileDownload(csv, 'judge_upload_template.csv');
   }

  return (
    <>
      <div className="loading-container">
        <h1>Loading Information</h1>
        <div>
          You can load information for your contest using a CSV file.
          You can save Excel and Google Doc files as CSV files.
          <ul>
            <li>
              <strong>Google Sheets</strong> Select File, then Download then
              as Comma-separated values (.csv)
            </li>
            <li>
              <strong>Excel</strong> Select File, Save as, then change type to
              (*.csv)
            </li>
          </ul>
        </div>
        <div className=''>

          <h3>Load Judges</h3>
          <p>
          If you don't want your judges to register, or have the register in another system. 
          <br/>No worries you can upload them here. Fill out the form below to be able to upload them.
          </p>
          <div className="flex-between">
                    <h4>File Format</h4>
                    <button className='btn btn-secondary btn-xs' onClick={downloadTemplateClick}>Download Template</button>
          </div>
          <div>
            The Judges CSV file should include the following columns in the following
            order.
            <ul>
              <li>First Name</li>
              <li>Last Name</li>
              <li>Email</li>
              <li>Phone</li>
              <li>Street</li>
              <li>Street 2</li>
              <li>City</li>
              <li>State</li>
              <li>Zip</li>
              <li>Desired username (if blank one will be set)</li>
              <li>Desired password (if blank one will be set)</li>
              <li>Employer/Organization</li>
              <li>Category preference 1</li>
              <li>Category preference 2</li>
              <li>Category preference 3</li>
              {additionalColumns.map((col, i) => {
              return (
                <li key={`${col.id}-${i}`}>{col.value} <span onClick={() => handleRemoveCol(col.id)}><i className="far fa-trash-alt"></i></span></li>
              )
            })
            }
            </ul>

          </div>

          <div className='form-group soft-border'>
            {/* Style this stuff here */}
            <p>Use this drop down and button to add additional columns that you want for uploading data.</p>
<div className="flex-between">
            <select className='form-control' onChange={(e) => handleColumnToAddChange(e)} value={columnToAdd?.id || -1}>
              <option value={-1}> </option>
              {/* <option value="password">Password</option>
              <option value="username">Username</option>
              <optgroup label="Project">
                <option value='ProjectDescription'>Description</option>
                <option value='ProjectAbstract'>Abstract</option>
                <option value='ProjectPlan'>Plan</option>
                <option value='ProjectURL'>URL</option>
                <option value='ProjectVideoLink'>Video Link</option>
                <option value='fixed-project-id'>Fixed Project Id</option>
              </optgroup> */}
              <optgroup label='Judges Custom Questions'>
                {customQuestionsPerson?.map(q => { return <option key={q.id} value={q.id}>{q.value}</option>})}
              </optgroup>

            </select>
            <button onClick={handleAddColumn} className='btn btn-primary'>add column</button>
            </div>
          </div>


          {!loaded && <div className="">

            <div className='bumper-l'>
            <label>Delimiter: </label>
              <select className="form-control" onChange={ e => setUploadType((e.target.value as UploadType))} value={uploadType}>
                <option value={'comma'}>Comma</option>
                <option value={'tab'}>Tab</option>
              </select>
            </div>
            <div className='bumper-l'>

            <label className=''>Judges CSV File:</label>
              <input
                type="file"
                accept=".csv"

                onChange={judgeCSVFileSelected}
                onClick={(evt: any) => evt.target.value = null}
              // Set target to null so the onchange event will fire again even if the user picks the same file.
              />
            </div>
            

            <div className='flex bumper-l'>
              <label htmlFor='headers'>Does the file include headers?</label>
              <input
                type='checkbox'
                name="headers"
                id='headers'
                className='form-input bumper-sides-out-l'
                onChange={e => setHeadersIncluded(e.target.checked)}
                defaultChecked={headersIncluded}
              />
            </div>


            {fileText && fileText.length > 0 && (
              <div className="csv-file-preview">
                <table>
                  {!headersIncluded
                    &&
                    <thead>
                      <tr>
                        <th>First Name</th>
                        <th>Last Name</th>
                        <th>Email</th>
                        <th>Phone</th>
                        <th>Street</th>
                        <th>Street 2</th>
                        <th>City</th>
                        <th>State</th>
                        <th>Zip</th>
                        <th>Category preference 1</th>
                        <th>Category preference 2</th>
                        <th>Category preference 3</th>
                        <th>Desired username (if blank one will be set)</th>
                        <th>Desired password (if blank one will be set)</th>
                      </tr>
                    </thead>

                  }
                  <tbody>

                    {fileText.map((r, ri) => {
                      return (
                        <tr key={'r' + ri}>
                          {r.map((v, vi) => {
                            if (headersIncluded && ri === 0) {
                              return <th key={ri + '-' + vi}>{v}</th>;
                            }
                            return <td key={ri + '-' + vi}>{v}</td>;
                          })}
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </div>
            )}
            {parsingErrors && parsingErrors.length > 0 &&
              <table>
                {parsingErrors.map((error, index) => (
                  <tr key={index}>
                    <td>{error}</td>
                  </tr>
                ))}
              </table>
            }
          </div>}
          {!loaded && (fileText && fileText.length > 0) 
            && (
              <div className='ready-to-load-area'>
                <h4>If the Judge file contents look good, press Load</h4>
                <div>
                  Send welcome email: <input type='checkbox' defaultChecked={sendWelcomeEmail} onChange={e => setSendWelcomeEmail(e.target.checked)} />
                  <br/>
                  Send sign-in credentials: <input type='checkbox' defaultChecked={sendSignInCredentials} onChange={e => setSendSignInCredentials(e.target.checked)} />
                  <br/>
                  Require password change on first login: <input type='checkbox' defaultChecked={requirePasswordChange} onChange={e => setRequirePasswordChange(e.target.checked)} />
                  <br/>

                </div>
                <button type="button" className="btn btn-success" onClick={load}>
                  <i className="fad fa-cloud-upload"></i>
                  Load
                </button>
              </div>
           )
          }
          {loaded && <div>
            <h1>Judges loaded!</h1>
            If you need to load more judges refresh your page.
            </div>}
        </div>

      </div>
    </>
  );
}

export default JudgesUpload 